import React from "react";
import { BadgeCheck } from "lucide-react";

export function Verified({ size = 16 }) {
  return <BadgeCheck size={size} className="text-[#3F8CFF] inline-block" fill="#E0EBFF" />;
}
